import React, { useState, useEffect } from "react";
import api from "../../services/api";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./Footer";
import VLibras from "./VLibras";
import useSettings from "../../hooks/useSettings";

const DEFAULT_CONTENT = `
<h2>1. Escopo do serviço</h2>
<p>Oferecemos uma solução SaaS para gestão de atendimentos omnichannel com recursos de IA, automações e integrações. As funcionalidades podem variar conforme o plano contratado e poderão receber melhorias contínuas sem aviso prévio, mantendo sempre a compatibilidade com fluxos principais.</p>
<h2>2. Credenciais e segurança</h2>
<p>O cliente é responsável por manter usuários e senhas seguros. Aconselhamos ativar duplo fator quando disponível, revisar permissões periodicamente e notificar o suporte ao identificar acessos suspeitos.</p>
<h2>3. Responsabilidade do conteúdo</h2>
<p>Mensagens enviadas pelos canais conectados são de responsabilidade do contratante. O uso deve obedecer às políticas de cada provedor (WhatsApp, Meta, APIs) e às legislações vigentes, evitando SPAM, fraudes ou violações de privacidade.</p>
<h2>4. Suporte e disponibilidade</h2>
<p>Mantemos estrutura redundante e monitoramento 24/7. Em caso de manutenção programada avisaremos nos canais oficiais. O SLA segue o plano contratado e contempla suporte via tickets, chat ou WhatsApp.</p>
<h2>5. Suspensão e cancelamento</h2>
<p>Reservamo-nos o direito de suspender contas por inadimplência, uso abusivo ou violação de termos. Cancelamentos podem ser solicitados a qualquer momento e entrarão em vigor ao final do ciclo vigente.</p>
`;

const TermsOfService = () => {
  const { getPublicSetting } = useSettings();
  const [content, setContent] = useState(null);
  const [appName, setAppName] = useState("");

  useEffect(() => {
    getPublicSetting("appName").then(v => { if (v) setAppName(v); }).catch(() => {});
    api.get("/open/terms-of-service")
      .then(({ data }) => setContent(data?.value || ""))
      .catch(() => setContent(""));
  }, []); // eslint-disable-line

  const scroll = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  if (content === null) return null;

  return (
    <div style={{ minHeight: "100vh", background: "#F0F9FF", display: "flex", flexDirection: "column" }}>
      <style>{`
        .legal-wrap { max-width: 900px; margin: 0 auto; padding: 104px 24px 80px; flex: 1; }
        .legal-card { background: #fff; border-radius: 24px; padding: 40px; box-shadow: 0 4px 24px rgba(0,0,0,.08); border: 1px solid rgba(79,70,229,.08); }
        .legal-card h1 { font-size: 36px; font-weight: 700; color: #1e1b4b; margin-bottom: 8px; }
        .legal-card h2 { margin-top: 32px; font-size: 22px; color: #4338ca; }
        .legal-card p, .legal-card li { color: #475467; line-height: 1.7; }
        .legal-card ul { padding-left: 20px; }
        @media (max-width: 768px) { .legal-card { padding: 24px; } .legal-card h1 { font-size: 28px; } }
      `}</style>

      <LandingHeader scrollTo={scroll} />

      <main style={{ flex: 1 }}>
        <div className="legal-wrap">
          <div className="legal-card">
            <h1>Termos de Serviço</h1>
            {content
              ? <div dangerouslySetInnerHTML={{ __html: content }} />
              : <div dangerouslySetInnerHTML={{ __html: DEFAULT_CONTENT }} />
            }
          </div>
        </div>
      </main>

      <LandingFooter appName={appName} />
      <VLibras />
    </div>
  );
};

export default TermsOfService;
